import React from "react";
import zaye from "./zaye.png";
import { Link } from "react-router-dom";
import compare from "./compare.png";

export default function Ourwork() {
  const stats = [
    {
      data: "35K",
      title: "Customers",
    },
    {
      data: "10K+",
      title: "Downloads",
    },
    {
      data: "40+",
      title: "Countries",
    },
    {
      data: "30M+",
      title: "Total revenue",
    },
  ];

  return (
    <div>
      <section className="py-14">
        <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
          <div className="max-w-xl md:mx-auto">
            <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl">
              Our Feature Projects
            </h3>
            <p className="mt-3 text-gray-600">
              We provide high-end, quality projects that turn your business
              goals into digital solutions, whether it's a website, mobile app,
              or other software.
            </p>
          </div>
          <div className="flex gap-3 items-center mt-2 md:justify-center">
            <Link
              to="/Contactus"
              className="inline-block py-2 px-4 text-gray-800 font-medium duration-150 border hover:bg-gray-50 active:bg-gray-100 rounded-lg"
            >
              Request a quote today.
            </Link>
          </div>
        </div>
      </section>

      <section className="py-4">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          <ul className="flex flex-col items-center justify-center gap-x-12 gap-y-10 sm:flex-row sm:flex-wrap md:gap-x-24">
            {stats.map((item, idx) => (
              <li key={idx} className="text-center">
                <h4 className="text-4xl text-gray-800 font-semibold">
                  {item.data}
                </h4>
                <p className="mt-3 text-gray-600 font-medium">{item.title}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
      
      <section className="py-14">
        <div className="max-w-screen-xl mx-auto md:px-8">
          <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
          <div className="flex-1 sm:hidden lg:block">
              <img
                src={zaye}
                className="md:max-w-lg sm:rounded-lg bg-black"
                alt="Zaye Captial Markets"
              />
            </div>
            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
              <p className="text-gray-800 text-3xl font-semibold sm:text-4xl">
                Zaye Capital Markets
              </p>

              <p className="mt-3 text-gray-600">
                By incorporating the latest web development practices and
                leveraging the capabilities of WordPress, JNY Labs has created a
                platform that not only meets but exceeds the requirements of
                Zaye Capital Markets. The website ensures that visitors can
                effortlessly explore the firm's offerings, access valuable
                research insights, and connect with experienced professionals to
                discuss their investment goals. Feel free to visit the Zaye
                Capital Markets website to witness firsthand the superior work
                quality delivered by JNY Labs. Experience the seamless
                functionality, aesthetic appeal, and user-friendly interface
                that have become synonymous with JNY Labs' development
                expertise.
              </p>
              <a
                href="https://zayecapitalmarkets.com"
                target="_blank"
                className="inline-flex gap-x-1 items-center text-green-500 hover:text-black duration-150 font-medium"
              >
                View live
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>
            
          </div>
        </div>


      </section>

      <section className="py-14 hover:Zoom-in">
        <div className="max-w-screen-xl mx-auto md:px-8">
          <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
            <img
              src={compare}
              className="md:max-w-lg sm:rounded-lg bg-black"
              alt="Zaye Captial Markets"
            />
            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
              <p className="text-gray-800 text-3xl font-semibold sm:text-4xl">
                Compare Broker
              </p>

              <p className="mt-3 text-gray-600">
                CompareBroker is a meticulously crafted website that enables
                users to effortlessly discover and select the ideal forex,
                stocks, commodities, and crypto brokers/exchanges tailored to
                their unique trading requirements. With its intuitive design and
                extensive array of features, this platform offers a wealth of
                information to empower traders. The website has been expertly
                developed by highly skilled professionals who have gone above
                and beyond to ensure an exceptional experience for its esteemed
                clients.
              </p>
              <a
                href="https://comparebroker.io"
                target="_blank"
                className="inline-flex gap-x-1 items-center text-green-500 hover:text-black duration-150 font-medium"
              >
                View live
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-screen-xl mx-auto md:px-8">
          <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
            <div className="flex-1 sm:hidden lg:block">
              <img
                src="https://play-lh.googleusercontent.com/8ZcSHjzfd_PG3EXil6mIr1cnYsY6yDibixymz4q4dCH4vObeZu6p2JqlgTdMLTXjvQ=w832-h470"
                className="md:max-w-lg sm:rounded-lg"
                alt=""
              />
            </div>
            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
              <p className="text-gray-800 text-3xl font-semibold sm:text-4xl">
                ShowUp
              </p>

              <p className="mt-3 text-gray-600">
                Introducing Showup: The groundbreaking dating app that takes
                your search for love and connection to the next level. Developed
                by JNY Labs' team of experienced developers, using cutting-edge
                technology including Flutter, Showup To Meetup revolutionizes
                the dating experience like never before. Our team at JNY Labs
                has extensive experience in developing robust and user-friendly
                apps, and we've poured that expertise into creating Showup To
                Meetup. We believe that technology should enhance human
                connections, and this app is a testament to that vision. We've
                harnessed the power of Flutter, a powerful framework known for
                its versatility and performance, to provide you with a seamless
                and intuitive user experience.
              </p>
              <a
                href="https://play.google.com/store/apps/details?id=com.company.showuptomeetup"
                target="_blank"
                className="inline-flex gap-x-1 items-center text-green-500 hover:text-black duration-150 font-medium"
              >
                View live
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
